export default "__VITE_ASSET__muWrvJrE__"